import { Alert, Button, Empty, Spin } from 'antd'
import { EyeOutlined, ReloadOutlined } from '@ant-design/icons'
import { useState } from 'react'

/**
 * PDF önizleme.
 *
 * Önizleme otomatik tetiklenmez: her render LibreOffice'e bir dönüşüm demek ve o servis seri çalışıyor.
 * Kullanıcı istediğinde üretilir.
 */
export default function PreviewPane({ onPreview, definition, language, t = (x) => x }) {
    const [loading, setLoading] = useState(false)
    const [pdf, setPdf] = useState('')
    const [warnings, setWarnings] = useState([])
    const [error, setError] = useState('')

    const run = async () => {
        if (!onPreview) return

        setLoading(true)
        setError('')
        try {
            const result = await onPreview(definition, language)
            if (result && result.pdfFile) {
                setPdf(`data:application/pdf;base64,${result.pdfFile}`)
                setWarnings(result.warnings || [])
            } else {
                setError(t('Önizleme üretilemedi'))
            }
        } catch (e) {
            setError((e && e.message) || t('Önizleme üretilemedi'))
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="tb-preview">
            <Button
                size="small"
                type="primary"
                icon={pdf ? <ReloadOutlined /> : <EyeOutlined />}
                loading={loading}
                onClick={run}
                block
            >
                {pdf ? t('Önizlemeyi Yenile') : t('Önizleme')}
            </Button>

            {error && <Alert type="error" showIcon message={error} style={{ marginTop: 8 }} />}

            {warnings.length > 0 && (
                <Alert
                    type="warning"
                    showIcon
                    style={{ marginTop: 8 }}
                    message={t('Uyarılar')}
                    description={<ul style={{ margin: 0, paddingLeft: 16 }}>{warnings.map((w, i) => <li key={i}>{w}</li>)}</ul>}
                />
            )}

            <div className="tb-preview-frame">
                {loading && <div className="tb-preview-loading"><Spin /></div>}
                {!loading && !pdf && (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('Önizleme için düğmeye basın')} />
                )}
                {!loading && pdf && <iframe title="preview" src={pdf} className="tb-preview-iframe" />}
            </div>
        </div>
    )
}
